import { render, staticRenderFns } from "./FavoriteHeadOuter.vue?vue&type=template&id=48563642&scoped=true"
import script from "./FavoriteHeadOuter.vue?vue&type=script&lang=js"
export * from "./FavoriteHeadOuter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48563642",
  null
  
)

export default component.exports